import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PlannedShuttleBuss } from '../models/ShuttleBookingModel';
import { EditOrderShuttleBus } from '../models/orderModel';

@Injectable({
  providedIn: 'root'
})
export class OrderShuttleBusService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  orderShuttleBusPath = 'Shuttlebuss/Shuttlebuss.Service/ordershuttlebus';

  constructor(private http: HttpClient) {}


  public createOrderShuttleBus(routeCode: string, startDate: string): Observable<PlannedShuttleBuss> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/createordershuttlebus/${routeCode}/${startDate}`;
    return this.http.get<PlannedShuttleBuss>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public getOrderShuttleBusBetweenShuttleDate(shuttleDateFrom: string, shuttleDateTo: string): Observable<PlannedShuttleBuss[]> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/getordershuttlebus/${shuttleDateFrom}/${shuttleDateTo}`;
    return this.http.get<PlannedShuttleBuss[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }
  
  //TODO: Remove, not used
  public getOrderShuttleBusRouteBetweenShuttleDate(routeCode: string, shuttleDateFrom: string, shuttleDateTo: string): Observable<PlannedShuttleBuss[]> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/getordershuttlebus/${routeCode}/${shuttleDateFrom}/${shuttleDateTo}`;
    return this.http.get<PlannedShuttleBuss[]>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public setBusPlanned(orderShuttleBusId: string): Observable<PlannedShuttleBuss> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/setordershuttlebusplanned/${orderShuttleBusId}`;
    return this.http.get<PlannedShuttleBuss>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public setBusActive(orderShuttleBusId: string): Observable<PlannedShuttleBuss> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/setordershuttlebusactive/${orderShuttleBusId}`;
    return this.http.get<PlannedShuttleBuss>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public setBusDeparted(orderShuttleBusId: string): Observable<PlannedShuttleBuss> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/setordershuttlebusdeparted/${orderShuttleBusId}`;
    return this.http.get<PlannedShuttleBuss>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public setBusArrived(orderShuttleBusId: string): Observable<PlannedShuttleBuss> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/setordershuttlebusarrived/${orderShuttleBusId}`;
    return this.http.get<PlannedShuttleBuss>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public setBusCancelled(orderShuttleBusId: string): Observable<PlannedShuttleBuss> {
    const URL = `${this.hostPath}${this.orderShuttleBusPath}/setordershuttlebuscancelled/${orderShuttleBusId}`;
    return this.http.get<PlannedShuttleBuss>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public editOrderShuttleBus(editOrderShuttleBus: EditOrderShuttleBus): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = `${this.hostPath}${this.orderShuttleBusPath}/editordershuttlebus`;
    return this.http
      .post<EditOrderShuttleBus>(url, editOrderShuttleBus, { headers })
      .pipe(map(orderShuttleBusVM => {
          return orderShuttleBusVM;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(`orderShuttleService.handleError ${errMsg}`);
    return throwError(error);
  }
}
